import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { AccountingMovementsImportComponent } from './accounting-movements-import.component';
import { DummyComponent } from '../../../../shared/dummy.component';
import { AccountingMovementsService } from '../accounting-movements.service';


@Component({
    selector: 'convfact-accounting-movements-import-dialog',
    templateUrl: './accounting-movements-import-dialog.html',
    styleUrls: ['../accounting-movements-list.component.css'],
    standalone: false
})

export class AccountingMovementsImportDialog {

    constructor(
        public dialogRef: MatDialogRef<AccountingMovementsImportComponent>,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        public dummy: DummyComponent,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private accountingMovementService: AccountingMovementsService,
    ) { }

    formData: FormData;
    flag: boolean = this.data.flag;

    dataReady = false;
    working = false;

    closeDialog() {
        this.dialogRef.close();
    }

    downloadTemplateContabilidad() {
        const url = window.open('https://www.handly.es/files/plantilla_normales.xlsx');
        url.focus();
    }

    downloadTemplateApertura() {
        const url = window.open('https://www.handly.es/files/plantilla_apertura.xlsx');
        url.focus();
    }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    fileChange(event, flagType: boolean) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            const file: File = fileList[0];
            const formData: FormData = new FormData();
            formData.append('file', file, file.name);
            this.formData = formData;
            this.accountingMovementService.accountMovementsImport(formData).then(response => {
                this.dialog
                    .open(AccountingMovementsImportComponent, {
                        width: '90vw',
                        maxWidth: '1200px',
                        maxHeight: '90vh',
                        data: {
                            data: response,
                            flagType: flagType
                        }
                    });
            })
        }
        this.dialogRef.close();
    }

}
